

































import Vue from "vue";
import { default as moment, Moment } from "moment-timezone";
import { Dictionary } from "vue-router/types/router";
import { Dame, currentTimestamp, MONATSNAMEN } from "@/api/Termine";
import { Studio } from "@/api/Studio";
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import MonatsUebersicht from "@/components/Monatsuebersicht.vue";

export default Vue.extend({
  name: "Monatsuebersicht",
  components: {
    ConfirmDialog,
    MonatsUebersicht,
  },
  data() {
    return {
      zeit: {} as Moment,
      monat: 1,
      jahr: 2021,
    };
  },
  created() {
    const routeParams = this.$route.params;

    if (routeParams) {
      if (routeParams.datum) {
        this.zeit = moment(routeParams.datum, "YYYY-MM-DD");
      }
    }

    this.$store.dispatch("appLoading", true);

    const gewaehlterTag = this.$store.getters["gewaehltesDatum"];
    if (gewaehlterTag) {
      this.zeit = moment(gewaehlterTag, "YYYY-MM-DD");
    } else {
      this.zeit = currentTimestamp();
    }
    this.updateZeit();
  },
  mounted() {
    this.updateZeit();

    const routeParams = this.$route.params;
    const params: Dictionary<string> = {};
    let nextRouteName = "";
    if (!routeParams || !routeParams.datum) {
      let datum = this.$store.getters["gewaehltesDatum"];
      if (!datum) {
        datum = currentTimestamp().format("YYYY-MM-DD");
        this.$store.dispatch("selectDatum", { datum });
      }
      nextRouteName = "Monatsuebersicht-mit-Datum";
      params["datum"] = datum.substring(0, 7); // YYYY-MM
    }

    if (nextRouteName !== "") {
      this.$router.push({
        name: nextRouteName,
        params,
      }).catch(failure => {
        // Ignore if isNavigationFailure(failure, NavigationFailureType.redirected)
      });
      return;
    }
  },
  computed: {
    ueberschriftAuswahl() {
      return `Monatsübersicht für ${MONATSNAMEN[(this as any).monat]} ${
        (this as any).jahr
      }`;
    },
    zurueckAktiv() {
      console.log('zurückAktiv: ', (this as any).jahr > 2021 || (this as any).monat > 6);
      return (this as any).jahr > 2021 || (this as any).monat > 6;
    },
  },
  watch: {
    "$route.params.datum": function(datum) {
      console.debug("Monatsübersicht / Datum wechselt: " + datum);
      const zeit = moment(datum, "YYYY-MM");
      if (zeit.isValid()) {
        this.zeit = zeit;
      } else {
        this.zeit = currentTimestamp();
      }
      this.updateZeit();
    },
    monat: function(monat) {
      const datum = this.zeit.format("YYYY-MM-DD");
      console.debug("Monatsuebersicht / Datum wechselt: " + datum);
      this.$nextTick().then(() => this.checkChangeRoute());
    },
  },
  methods: {
    checkChangeRoute() {
      if (this.zeit && this.zeit.isValid()) {
        const params: Dictionary<string> = {
          monat: this.zeit.format("YYYY-MM"),
        };
        const nextRouteName = "Monatsuebersicht-mit-Datum";
        const log = "Wechsle zu Monatsuebersicht-mit-Datum";
        if (
          this.$route.name != nextRouteName ||
          this.$route.params.monat !== params.monat
        ) {
          console.log(log);
          this.$router.push({
            name: nextRouteName,
            params,
          });
        }
      }
    },
    setMonth(offset: number) {
      if (offset < 0) {
        this.zeit.subtract(1, "month");
      } else if (offset > 0) {
        this.zeit.add(1, "month");
      }
      console.log("Monat verändert");
      this.updateZeit();
    },
    updateZeit() {
      if (this.zeit && this.zeit.isValid && this.zeit.isValid()) {
        this.monat = this.zeit.month();
        this.jahr = this.zeit.year();
        this.$store.dispatch("selectDatum", {
          datum: this.zeit.format("YYYY-MM-DD"),
        });
      }
    },
  },
});
